import React from 'react';
import styled from 'styled-components';
import Fade from 'react-reveal/Fade';
import Button from './Button';
import PText from './PText';
import SectionTitle from './SectionTitle';
import HorizontalLine from './HorizontalLine';
import trial2 from '../assets/images/trial2.jpg';

const AboutSectionStyles = styled.div`
  padding: 10rem 0;
  .container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
  }
  .aboutSection__left,
  .aboutSection__right {
    flex: 1;
  }
  .section-title {
    text-align: left;
  }
  .para {
    margin-top: 2rem;
    margin-left: 0;
  }
  .aboutSection__buttons {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 2rem;
    margin-top: 2rem;
  }
  @media only screen and (max-width: 950px) {
    .aboutSection__left {
      flex: 4;
    }
    .aboutSection__right {
      flex: 3;
    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      text-align: center;
    }
    .aboutSection__left,
    .aboutSection__right {
      width: 100%;
    }
    .aboutSection__right {
      margin-top: 3rem;
    }
    .section-title {
      text-align: center;
    }
    .para {
      margin: 0 auto;
      margin-top: 2rem;
    }
    .aboutSection__buttons {
      flex-direction: column;
      gap: 0rem;
      .button-wrapper,
      a {
        width: 100%;
        text-align: center;
      }
    }
  }
`;

export default function AboutSection() {
  return (
    <AboutSectionStyles>
      <HorizontalLine />
      <div className="container">
        <div className="aboutSection__left">
          <Fade left>
            <SectionTitle
              subheading="Let me introduce myself"
              heading="About Me"
            />

            <PText>
              I am Software Developer Specialized in Web Development and Tech
              Enthusiast from Agra, Uttar Pradesh, India. I love to code, solve
              problems and work with different technologies.
            </PText>

            <div className="aboutSection__buttons">
              <Button btnText="Works" btnLink="/projects" />
              <Button btnText="Read More" btnLink="/about" outline />
            </div>
          </Fade>
        </div>
        <div className="aboutSection__right">
          <Fade right>
            <img className="aboutImg" src={trial2} alt="Img" />
          </Fade>
        </div>
      </div>
    </AboutSectionStyles>
  );
}
